export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=409ab3fe7bce4c436445efdc1d9c0a871f2ba97de7&name=addToFolderEventAction!'